module.exports = __webpack_public_path__ + "static/318476315_666025191860586_5734426816503227517_n.jpg-1671186392511_512-ccca44666567fc9d5594d45e407e0283.webp";